import { useState, useRef } from 'react'
import { ChevronDown, MoveLeft } from 'lucide-react'
import './CourseLanding.css'
import logo from '../../assets/images/storiesLogo.svg'
import heroBg from '../../assets/images/lending/Rectangle 3.png'
import navFounder from '../../assets/images/lending/Group 2765.png'
import navMission from '../../assets/images/lending/Group 2766.png'
import navAudience from '../../assets/images/lending/Group 2767.png'
import navResults from '../../assets/images/lending/Group 2768.png'
import navProgram from '../../assets/images/lending/Group 2769.png'
import navPricing from '../../assets/images/lending/Group 2770.png'
import navFormat from '../../assets/images/lending/Group 2771.png'
import navFaq from '../../assets/images/lending/Group 2772.png'
import ownerPhoto from '../../assets/images/lending/owner.png'
import logoGray from '../../assets/images/lending/logo666.svg'
import decor1 from '../../assets/images/lending/Mask group.png'
import decor2 from '../../assets/images/lending/Mask group-1.png'
import decor3 from '../../assets/images/lending/Mask group-2.png'
import decor4 from '../../assets/images/lending/Mask group-3.png'
import decor5 from '../../assets/images/lending/Mask group-4.png'
import decor6 from '../../assets/images/lending/Rectangle 147.png'
import decor7 from '../../assets/images/lending/Rectangle 147-1.png'
import decor8 from '../../assets/images/lending/Rectangle 147-2.png'
import decor9 from '../../assets/images/lending/Rectangle 147-3.png'
import decor10 from '../../assets/images/lending/Rectangle 148.png'
import missionPhoto from '../../assets/images/lending/mission.png'
import audience1 from '../../assets/images/lending/Rectangle 135.png'
import audience2 from '../../assets/images/lending/Rectangle 139.png'
import audience3 from '../../assets/images/lending/Rectangle 149.png'
import audience4 from '../../assets/images/lending/Rectangle 137.png'
import audience5 from '../../assets/images/lending/Rectangle 150.png'
import module1 from '../../assets/images/lending/Rectangle 75modules.png'
import module2 from '../../assets/images/lending/Rectangle 103modules.png'
import module3 from '../../assets/images/lending/Rectangle 153modules.png'
import module4 from '../../assets/images/lending/Rectangle 154modules.png'
import module5 from '../../assets/images/lending/Rectangle 155modules.png'
import module6 from '../../assets/images/lending/sgrqerh 1modules.png'
import formatLearning1 from '../../assets/images/lending/formatlearning1.png'
import formatLearning2 from '../../assets/images/lending/formatlearning2.png'
import formatLearning3 from '../../assets/images/lending/formatlearning3.jpg'
import socialSecret from '../../assets/images/secret.png'
import socialConditerka from '../../assets/images/conditerka.png'
import socialWeddingTg from '../../assets/images/lending/Mask group-2.png'
import socialWeddingIg from '../../assets/images/lending/Frame 1336585414.png'
import logoLight from '../../assets/images/logoLight.svg'
import { formatPrice } from '../../utils/formatPrice'
import type { SubscriptionCurrency } from '../../types/api'
interface CourseLandingProps {
  onBuyClick: () => void
  /** Цена курса с бэкенда. Если не задана — блок цены скрыт. */
  price?: number
  /** Валюта цены (по умолчанию EUR). */
  currency?: SubscriptionCurrency
}

const NAV_ITEMS = [
  { label: 'About the founder', id: 'founder', image: navFounder },
  { label: 'Mission', id: 'mission', image: navMission },
  // { label: 'Who it’s for', id: 'audience', image: navAudience },
  { label: 'Results', id: 'results', image: navResults },
  { label: 'Course\nprogram', id: 'program', image: navProgram },
  { label: 'Pricing', id: 'pricing', image: navPricing },
  { label: 'Learning\nformat', id: 'format', image: navFormat },
  { label: 'FAQ', id: 'faq', image: navFaq },
]

const DECORS = [
  { title: 'Delicate Bows cake', image: decor1 },
  { title: 'Delicate Flowers cake', image: decor9 },
  { title: 'Beads cake', image: decor2 },
  { title: 'Tenderness cake', image: decor3 },
  { title: 'Korean Design cake', image: decor4 },
  { title: 'Italian Pie cake', image: decor6 },
  { title: 'Long cake', image: decor7 },
  { title: 'Origami cake', image: decor8 },
  { title: 'Cabbage cake', image: decor10 },
  { title: 'Drapes cake', image: decor5 },
]

const AUDIENCE_CARDS = [
  {
    title: 'Afraid\nthe cake will fall apart',
    description: 'won’t survive transport or will fail at the worst moment',
    variant: 'light' as const,
    image: audience1,
    solution:
      'Get a step-by-step assembly system with the right supports and fastenings. After it you’ll know exactly how to build a structure that survives transport anywhere',
  },
  {
    title: 'Unsure about calculations\nand proportions',
    description:
      'afraid the cake won’t fit in the fridge or won’t hold its own weight',
    variant: 'dark' as const,
    image: audience2,
    solution:
      'We give ready-made schemes and drawings for different formats, with precise measurements and ingredient recalculation. All proportions are adapted to a home fridge (except the bonus lesson)',
  },
  {
    title: 'Running into\nproblems',
    description: 'cracks in fondant, crooked tiers, melting cream',
    variant: 'light' as const,
    image: audience3,
    solution:
      'In the course we don’t just give a solution — we break down every typical mistake in detail: why cracks appear, how to properly coat a cake with ganache and fondant, and how to level tiers.',
  },
  {
    title: 'You want beautiful wedding designs',
    description:
      'but worry about the decor or don’t know where to start',
    variant: 'dark' as const,
    image: audience4,
    solution:
      '10 lessons on trending designs with step-by-step assembly and material calculation. The decor will be not only beautiful but securely fixed',
  },
  {
    title: 'Hit a ceiling',
    description: 'don’t know how to reach a new level of quality',
    variant: 'light' as const,
    image: audience5,
    solution:
      'The course is built as a complete system: from fillings and assembly to order management, timing, packaging and transport. It’s not just lessons but a ready base for confident work with wedding cakes',
  },
]

const MODULES = [
  {
    number: 1,
    title: 'Intro\nmodule',
    expandedTitle: 'Intro module',
    description: 'Tools, assembling fillings, calculating proportions',
    details: [
      {
        heading: 'Lesson 0',
        text: '“Introduction, getting acquainted, congratulations on joining the course, a short overview of the advantages of the wedding cake niche”',
      },
      {
        heading: 'Lesson 1',
        text: '“Essential tools for making and decorating wedding cakes, info on the fridge, boards, frame and supports”',
      },
      { heading: 'Lesson 2', text: '“Board”' },
      { heading: 'Lesson 3', text: '“Assembling fillings”' },
      { heading: 'Lesson 4', text: '“Cake proportions + recalculating fillings”' },
    ],
    variant: 'dark' as const,
    image: module3,
  },
  {
    number: 2,
    title: 'Cake\nfillings',
    expandedTitle: 'Fillings module',
    description: '8 unique and stable fillings by Pauline Cake',
    details: [
      { heading: 'Lesson 1', text: 'Pistachio–Raspberry cake' },
      { heading: 'Lesson 2', text: 'Tropical cake' },
      { heading: 'Lesson 3', text: 'Black Forest cake' },
      { heading: 'Lesson 4', text: 'Snickers cake' },
      { heading: 'Lesson 5', text: 'Vanilla–Berry cake' },
      { heading: 'Lesson 6', text: 'Nutella cake' },
      { heading: 'Lesson 7', text: 'Honey cake (Medovik)' },
      { heading: 'Lesson 8', text: 'Banana–Caramel cake' },
    ],
    variant: 'light' as const,
    image: module6,
  },
  {
    number: 3,
    title: 'Cake\ncoatings',
    expandedTitle: 'Coatings module',
    description: 'Ganache, fondant, velvet: flawless application',
    details: [
      {
        heading: 'Block 1',
        text: '“Ganache”',
        bullets: [
          'Types and benefits of ganache;',
          'Step-by-step ganache technique;',
          'Working with ganache;',
          'Common ganache mistakes and how to fix them',
        ],
      },
      {
        heading: 'Block 2',
        text: '“Fondant”',
        bullets: [
          'Types of fondant;',
          'Differences in properties and use of fondant;\n– How to work with fondant;\n– How to avoid cracks, bubbles and unwanted folds;\n– How to store fondant ',
        ],
      },
      {
        heading: 'Block 3',
        text: '“Velvet”',
        bullets: [
          'What it is + tips to keep your kitchen clean.',
          'Velvet recipe, coloring;',
          'How and with what to apply velvet',
        ],
      },
    ],
    variant: 'dark' as const,
    image: module4,
  },
  {
    number: 4,
    title: 'Assembly\nand structure',
    expandedTitle: 'Module “Structure and assembly of tiered cakes”',
    description: 'Assembling dummy tiers, real cakes and hybrids',
    details: [
      {
        heading: 'Block 1',
        text: '“Dummy tiers”',
        bullets: [
          'Principles of choosing and preparing dummy tiers;\n– Assembling a cake from dummy tiers: fixing and leveling;\n– Coating dummy tiers: ganache, cream, fondant;',
        ],
      },
      { heading: 'Block 2', text: '“Assembling real cakes”' },
      {
        heading: 'Block 3',
        text: '“Structure”',
        bullets: [
          'Principles of stability and safety of the structure',
          'Different ways to fasten tiers',
          'Boards and central dowels',
          'Marking and installing supports',
          'Assembling a hybrid cake + real insert in a dummy cake',
          'Drawings and schemes',
        ],
      },
    ],
    variant: 'dark' as const,
    image: module2,
  },
  {
    number: 5,
    title: 'Wedding cakes. Decor',
    expandedTitle: 'Module “Wedding cake decor”',
    description: '10 wedding designs\nwith step-by-step assembly',
    details: [
      { heading: 'Lesson 1', text: 'Delicate Bows cake' },
      { heading: 'Lesson 2', text: 'Korean Design cake' },
      { heading: 'Lesson 3', text: 'Ethereal Flowers cake' },
      { heading: 'Lesson 4', text: 'Beads cake' },
      { heading: 'Lesson 5', text: 'Cabbage cake' },
      { heading: 'Lesson 6', text: 'Tenderness cake' },
      { heading: 'Lesson 7', text: 'Italian Pie cake' },
      { heading: 'Lesson 8', text: 'Origami cake' },
      { heading: 'Lesson 9', text: 'Long cake' },
      { heading: 'Lesson 10', text: 'Drapes cake' },
    ],
    variant: 'light' as const,
    image: module1,
  },
  {
    number: 6,
    title: 'Packaging\nand delivery',
    expandedTitle: 'Module “Packaging and delivery”',
    description: 'Timing, measurements, packaging, handling emergencies',
    details: [
      {
        heading: 'Lesson 1',
        text: '“How to take orders and keep timing right” (also venue measurement, deadlines, booking a vehicle and other important points)',
      },
      { heading: 'Lesson 2', text: '“ Packaging a wedding cake”' },
      { heading: 'Lesson 2', text: '“Key points for working with delivery”' },
      {
        heading: 'Lesson 3',
        text: '“Main mistakes at work — what to do if?”',
      },
    ],
    variant: 'dark' as const,
    image: module5,
  },
]

const FORMAT_CARDS = [
  {
    title: 'Recorded lessons',
    description: 'Watch anytime that suits you',
    image: formatLearning1,
  },
  {
    title: 'Lifetime access',
    description: 'The course stays yours forever',
    image: formatLearning2,
  },
  {
    title: 'Mentor support',
    description: 'Help, feedback and support',
    image: formatLearning3,
  },
]

const FAQ_ITEMS = [
  {
    question: 'Is the course for beginners or only experienced bakers?',
    answer:
      'The course is designed for those who already have basic pastry skills. All technical aspects of working with tiered cakes (ganache, fondant, supports) are covered from scratch and in detail.',
  },
  {
    question: 'What if I have a home kitchen and an ordinary fridge?',
    answer:
      'We specifically adapted all proportions to standard home fridges. Only the final bonus lesson (a two-metre cake) requires industrial scale — it’s for inspiration and understanding the limits of what’s possible.',
  },
  {
    question: 'What equipment and tools will I need?',
    answer:
      'The course has a separate lecture on tools: from the essential minimum to things that make a baker’s life easier. All of it can be found in ordinary confectionery shops — nothing unique is required.',
  },
  {
    question: 'How long will I have access to the materials?',
    answer:
      'Access is forever. You can rewatch the lessons anytime and also ask the mentor questions.',
  },
  {
    question: 'Does the course include filling recipes?',
    answer:
      'Yes, 8 signature fillings we use at Pauline Cake. All with video and exact proportions.',
  },
  {
    question: 'Can I pay from another country?',
    answer: 'Yes, we accept international cards through the payment service.',
  },
]

const CourseLanding = ({ onBuyClick, price, currency }: CourseLandingProps) => {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null)
  const [openSolutionIndex, setOpenSolutionIndex] = useState<number | null>(
    null
  )
  const [openModuleIndex, setOpenModuleIndex] = useState<number | null>(null)
  const sectionRefs = useRef<Record<string, HTMLElement | null>>({})

  const scrollToSection = (id: string) => {
    sectionRefs.current[id]?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index)
  }

  return (
    <div className="cl-page">
      {/* === HERO === */}
      <section className="cl-hero">
        {/* Тёмный хедер-бар */}
        <div className="cl-hero-header">
          <img src={logo} alt="" className="cl-hero-logo" />
        </div>
        {/* Фото-блок с оверлеем */}
        <div
          className="cl-hero-photo"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="cl-hero-overlay">
            <div className="cl-hero-badge">New program</div>
            <div className="cl-hero-title-block">
              <h1 className="cl-hero-title">WEDDING COURSE</h1>
              <p className="cl-hero-subtitle">by PAULINE CAKE</p>
            </div>
          </div>
          {/* Кнопка покупки — поверх нижней границы фото */}
          <button className="cl-hero-cta" onClick={onBuyClick}>
            BUY THE COURSE
          </button>
        </div>
      </section>

      {/* === NAV === */}
      <section className="cl-nav">
        <div className="cl-nav-scroll">
          {NAV_ITEMS.map(item => (
            <button
              key={item.id}
              className="cl-nav-item"
              onClick={() => scrollToSection(item.id)}
            >
              <img
                src={item.image}
                alt={item.label}
                className="cl-nav-circle"
              />

              <span className="cl-nav-label">{item.label}</span>
            </button>
          ))}
        </div>
      </section>

      {/* === WEDDING CAKE TITLE === */}
      <section className="cl-wedding-title">
        <h2 className="cl-wedding-heading">WEDDING CAKE</h2>
        <p className="cl-wedding-desc">
          A course on tiered cakes by Pauline Cake{'\n'}
          A complete system from fillings to assembling tiered cakes and
          trending decor
        </p>
      </section>

      {/* === FOUNDER === */}
      <section
        className="cl-founder"
        ref={el => {
          sectionRefs.current['founder'] = el
        }}
      >
        <div className="cl-founder-card">
          <img src={ownerPhoto} alt="Founder" className="cl-founder-photo" />
          <div className="cl-founder-logo">
            <span className="cl-section-label">Founder</span>
            <img src={logoGray} alt="" />
          </div>
          <div className="cl-founder-text">
            <p>Hi, this is Polina! </p>
            <p>
              I’m a pastry chef with 12 years of experience, founder of Pauline
              Cake in Dubai — you may know me from popular social media videos.
            </p>
            <p>
              One of my best projects, which I’m incredibly proud of, is SECRET
              CHAT — a private community where I share recipes from our workshop,
              decorating techniques and pastry business strategies.
            </p>
          </div>
        </div>
      </section>

      {/* === DECORS === */}
      <section
        className="cl-decors"
        ref={el => {
          sectionRefs.current['results'] = el
        }}
      >
        <div className="cl-decors-title-block">
          <h3 className="cl-section-title">Decor in the wedding course</h3>
          <img src={logoGray} alt="" className="cl-decors-logo" />
        </div>

        <div className="cl-decors-scroll">
          {DECORS.map((decor, idx) => (
            <div key={idx} className="cl-decor-card">
              <img
                src={decor.image}
                alt={decor.title}
                className="cl-decor-image"
              />
              <p className="cl-decor-name">{decor.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* === SOCIAL === */}
      <section className="cl-social">
        <div className="cl-social-top">
          <h3 className="cl-social-title">Social media</h3>
          <img src={logoGray} alt="" className="cl-social-logo" />
        </div>
        <div className="cl-social-icons">
          <a
            href="https://www.instagram.com/pauline_secret_chat?igsh=aHc3YWVhYTRybXU1"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialSecret}
              alt="Secret Chat"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://telegram.me/+HE28136iRUA4MDEy"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialConditerka}
              alt="Konditerka"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://www.instagram.com/pauline_wedding_course?igsh=MTl0ano3aml5dDEzcQ=="
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialWeddingIg}
              alt="Wedding Course IG"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://telegram.me/pauline_wedding_course"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialWeddingTg}
              alt="Wedding Course TG"
              className="cl-social-icon-img"
            />
          </a>
        </div>
      </section>

      {/* === MISSION === */}
      <section
        className="cl-mission"
        ref={el => {
          sectionRefs.current['mission'] = el
        }}
      >
        <div className="cl-mission-card">
          <img
            src={missionPhoto}
            alt="Founder"
            className="cl-founder-photo"
          />
          <div className="cl-founder-logo">
            <span className="cl-section-label">Wedding course mission</span>
            <img src={logoGray} alt="" />
          </div>
          <div className="cl-founder-text">
            <p>
              {' '}
              I know many people are scared to start with wedding cakes because
              of the special responsibility.{' '}
            </p>
            <p>
              My job is to give you a system and immerse you in every process so
              you feel in control of wedding cakes yourself.
            </p>
            <p>
              You’ll know exactly which filling to choose, how to calculate
              proportions for any fridge, how to build reliable supports,
              coat a cake perfectly and decorate it so the decor won’t fall off
              on the way. Everything we’ve developed over years at Pauline Cake —
              for your calm and successful wedding season.
            </p>
          </div>
        </div>
      </section>

      {/* === AUDIENCE === */}
      {/* <section
        className="cl-audience"
        ref={el => {
          sectionRefs.current['audience'] = el
        }}
      >
        <h2 className="cl-audience-course-name">WEDDING COURSE</h2>

        <h3 className="cl-section-title">is for you if you:</h3>
        <div className="cl-audience-scroll">
          {AUDIENCE_CARDS.map((card, idx) => {
            const isOpen = openSolutionIndex === idx
            return (
              <div
                key={idx}
                className={`cl-audience-card cl-audience-card--${card.variant}`}
              >
                {isOpen ? (
                  <div className="cl-audience-solution-block">
                    <div
                      className="cl-audience-card-btn cl-audience-card-btn--active"
                      onClick={() => setOpenSolutionIndex(null)}
                    >
                      <MoveLeft size={14} />
                    </div>
                    <h4 className="cl-audience-solution-title">Solution</h4>
                    <p className="cl-audience-solution-text">{card.solution}</p>
                  </div>
                ) : (
                  <>
                    <div className="cl-audience-card-body">
                      <h4 className="cl-audience-card-title">{card.title}</h4>
                      <p className="cl-audience-card-desc">
                        {card.description}
                      </p>
                      <div
                        className="cl-audience-card-btn"
                        onClick={() => setOpenSolutionIndex(idx)}
                      >
                        <span>Solution</span>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )
          })}
        </div>
      </section> */}

      {/* === PROGRAM === */}
      <section
        className="cl-program"
        ref={el => {
          sectionRefs.current['program'] = el
        }}
      >
        <div className="cl-program-header">
          <span className="cl-program-label">Program</span>
          <h2 className="cl-program-course-name">WEDDING COURSE</h2>
        </div>
        <div className="cl-program-scroll">
          {MODULES.map((mod, idx) => {
            const isOpen = openModuleIndex === idx
            return (
              <div
                key={mod.number}
                className={`cl-module-card cl-module-card--${mod.variant}${isOpen ? ' cl-module-card--open' : ''}`}
              >
                {isOpen ? (
                  <div className="cl-module-detail-block">
                    <div
                      className="cl-module-back-btn"
                      onClick={() => setOpenModuleIndex(null)}
                    >
                      <MoveLeft size={14} />
                    </div>
                    <h4 className="cl-module-detail-title">
                      {mod.expandedTitle}
                    </h4>
                    <div className="cl-module-detail-text">
                      {mod.details.map((section, i) => (
                        <div key={i} className="cl-module-detail-section">
                          <p>
                            <strong>{section.heading}</strong> {section.text}
                          </p>
                          {'bullets' in section && section.bullets && (
                            <ul className="cl-module-detail-bullets">
                              {section.bullets.map((item, j) => (
                                <li key={j}>{item}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="cl-module-card-block">
                      <div className="cl-module-badge">
                        <span>Module {mod.number}</span>
                      </div>
                      <h4 className="cl-module-title">{mod.title}</h4>
                      <p className="cl-module-desc">{mod.description}</p>
                    </div>
                    <img
                      src={mod.image}
                      alt={mod.title}
                      className="cl-module-image"
                    />
                    <div
                      className="cl-module-more"
                      onClick={() => setOpenModuleIndex(idx)}
                    >
                      <span>More</span>
                    </div>
                  </>
                )}
              </div>
            )
          })}
        </div>
      </section>

      {/* === PRICING === */}
      <section
        className="cl-pricing"
        ref={el => {
          sectionRefs.current['pricing'] = el
        }}
      >
        <h2 className="cl-pricing-label">Choose a plan</h2>
        <div className="cl-pricing-card">
          {price != null && (
            <div className="cl-pricing-prices">
              <span className="cl-pricing-new">{formatPrice(price, currency)}</span>
            </div>
          )}

          <button className="cl-pricing-cta" onClick={onBuyClick}>
            BUY THE COURSE
          </button>
        </div>
      </section>

      {/* === FORMAT === */}
      <section
        className="cl-format"
        ref={el => {
          sectionRefs.current['format'] = el
        }}
      >
        <h2 className="cl-format-course-name">WEDDING COURSE</h2>
        <h3 className="cl-section-title">Learning format</h3>
        <div className="cl-format-scroll">
          {FORMAT_CARDS.map((card, idx) => (
            <div key={idx} className="cl-format-card">
              <img
                src={card.image}
                alt={card.title}
                className="cl-format-card-image"
              />
              <div className="cl-format-card-body">
                <h4 className="cl-format-card-title">{card.title}</h4>
                <p className="cl-format-card-desc">{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* === FAQ === */}
      <section
        className="cl-faq"
        ref={el => {
          sectionRefs.current['faq'] = el
        }}
      >
        <h2 className="cl-faq-label">FAQ</h2>
        <h3 className="cl-section-title">Frequently asked questions</h3>
        <div className="cl-faq-list">
          {FAQ_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className={`cl-faq-item ${openFaqIndex === idx ? 'cl-faq-item--open' : ''}`}
              onClick={() => toggleFaq(idx)}
            >
              <div className="cl-faq-question">
                <span>{item.question}</span>
                <ChevronDown size={16} className="cl-faq-chevron" />
              </div>
              {openFaqIndex === idx && item.answer && (
                <div className="cl-faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* === FOOTER === */}
      <section className="cl-footer cl-social cl-footer-social-icons">
        <div className="cl-social-top">
          <h3 className="cl-social-title cl-footer-social-title">
            Social media
          </h3>
          <img src={logoLight} alt="" className="cl-social-logo" />
        </div>
        <div className="cl-social-icons ">
          <a
            href="https://www.instagram.com/pauline_secret_chat?igsh=aHc3YWVhYTRybXU1"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialSecret}
              alt="Secret Chat"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://telegram.me/+HE28136iRUA4MDEy"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialConditerka}
              alt="Konditerka"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://www.instagram.com/pauline_wedding_course?igsh=MTl0ano3aml5dDEzcQ=="
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialWeddingIg}
              alt="Wedding Course IG"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://telegram.me/pauline_wedding_course"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialWeddingTg}
              alt="Wedding Course TG"
              className="cl-social-icon-img"
            />
          </a>
        </div>
      </section>
    </div>
  )
}

export default CourseLanding
